import React, { InputHTMLAttributes, useCallback } from 'react';
import { memoNamed } from '../../utils/react/memo-named';

interface Props
  extends Omit<
    React.DetailedHTMLProps<
      InputHTMLAttributes<HTMLInputElement>,
      HTMLInputElement
    >,
    'value' | 'onChange'
  > {
  value: string;
  onValueChange: (value: string) => void;
}

export const StringInput = memoNamed<Props>(
  'StringInput',
  ({ value, onValueChange, ...props }: Props) => {
    const onChange = useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        onValueChange(event.target.value);
      },
      [onValueChange]
    );

    return <input value={value} onChange={onChange} {...props} />;
  }
);
